<template lang="pug">
.page
  post-form
</template>

<script>
import PostForm from '@/components/post/post-form'

export default {
  name: 'create-post',
  components: {
    PostForm,
  },
}
</script>

